const triggerDivs = document.querySelectorAll('.question-trigger');
triggerDivs.forEach((triggerDiv) => {
  triggerDiv.addEventListener('click', (e) => toggleAccordion(triggerDiv));
});

function toggleAccordion (triggerDiv) {
  const contentDiv = triggerDiv.nextElementSibling;
  const iconDiv = triggerDiv.querySelector('.toggle-button');

  toggleBtnIcon(iconDiv);
  contentDiv.classList.toggle('active');
}

function toggleBtnIcon (iconDiv) {
  if (iconDiv.classList.contains('close')) {
    iconDiv.classList.remove('close');
    iconDiv.classList.add('open');
  } else {
    iconDiv.classList.add('close');
    iconDiv.classList.remove('open');
  }
}
